import cx from 'classnames';
import { Icon } from '@components/icon/Icon';
import { parseToDayMonthFormat } from '@shared/utils/dateFormatters';
import { ISOTimeTo12HourTime } from '@utils/time';
import typography from '~styles/typography.scss';
import styles from './ReservationAttributesGrid.scss';

export interface ReservationAttributesLayoutProps {
  containerClassName?: string;
  date: string;
  guestCount: number;
  publicName: null | string;
  time: string;
  variant?: 'grid' | 'inline';
}

export const ReservationAttributesGrid = ({
  containerClassName,
  date,
  guestCount,
  publicName,
  time,
  variant = 'grid',
}: ReservationAttributesLayoutProps) => {
  return (
    <div className={cx(styles.container, containerClassName, variant)}>
      <div className={cx(styles.attribute, styles.date)}>
        <Icon name="calendar" className={styles.icon} />
        <span className={typography.t1}>{parseToDayMonthFormat(date)}</span>
      </div>
      <div className={cx(styles.attribute, styles.time)}>
        <Icon name="clock" className={styles.icon} />
        <span className={typography.t1}>{ISOTimeTo12HourTime(time)}</span>
      </div>
      <div className={cx(styles.attribute, styles.guestCount)}>
        <Icon name="couple" className={styles.icon} />
        <span className={typography.t1}>{guestCount}</span>
      </div>

      {publicName && (
        <div
          className={cx(styles.attribute, styles.publicName)}
          data-testid="table"
        >
          <Icon name="table" className={styles.icon} />
          <span className={cx(typography.t1, styles.table)}>{publicName}</span>
        </div>
      )}
    </div>
  );
};
